module.exports = __webpack_public_path__ + "static/emma-doodle-ee7aaf0f367401468dfbb12838da1fd2.svg";